import {FilterMetadataMap, FromFilterDefinition, NonNullableFilterValues, NullableFilterValues,} from "../filtering";
import {SortSelectionObject} from "../common";


export const SALES_ORDER_SORT_COLUMNS = {
    client: 'client',
    project: 'project',
    date: 'date',
    status: 'status',
} as const;

export const SALES_ORDER_DEFAULT_SORT: SortSelectionObject<typeof SALES_ORDER_SORT_COLUMNS> = {
    column: 'date',
    direction: 'desc'
}

export const SALES_ORDER_FILTER_DEFINITION = {
    search: 'string',
    client: 'string[]',
    project: 'string[]',
    date: 'DateFilter',
    status: 'string[]',
    amount: 'number',
    projectManager: 'string[]',
    notes: 'number',
} as const;

export const SALES_ORDER_STATUS_VALUES = [
    'OPEN',
    'CLOSED'
] as const;

export const SALES_ORDER_FILTER_METADATA = {
    status: {
        kind: 'enum' as const,
        enumValues: SALES_ORDER_STATUS_VALUES,
        isArray: true,
    },
} as const satisfies FilterMetadataMap<typeof SALES_ORDER_FILTER_DEFINITION>;

export type SalesOrderFilterDefinition = FromFilterDefinition<typeof SALES_ORDER_FILTER_DEFINITION>

export type NullableSalesOrderFilter = NullableFilterValues<SalesOrderFilterDefinition>;
export type NonNullableSalesOrderFilter =
    NonNullableFilterValues<SalesOrderFilterDefinition>;

export const DEFAULT_SALES_ORDER_FILTER: NullableSalesOrderFilter = {
    search: null,
    client: null,
    project: null,
    date: null,
    status: null,
    amount: null,
    projectManager: null,
    notes: null
};
